// extracted by mini-css-extract-plugin
export default {"ModalBlock":"modal-with-buttons_ModalBlock__+h5YR","headerText":"modal-with-buttons_headerText__fysJX","buttonsRow":"modal-with-buttons_buttonsRow__EMZe+"};